<script lang="ts" setup>
import { useSlots } from 'vue';

defineProps<{
    propertiesMode: boolean;
}>();

const slots = useSlots();
</script>

<template>
    <div class="overflow-hidden">
        <slot v-if="!propertiesMode" name="default"></slot>
        <slot v-if="propertiesMode && slots?.properties" name="properties"></slot>
    </div>
</template>
